import { render, staticRenderFns } from "./CbxMortgageType.vue?vue&type=template&id=4324e596&"
import script from "./CbxMortgageType.vue?vue&type=script&lang=ts&"
export * from "./CbxMortgageType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports